import { createListPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/dashboard'

import Content from './content'
import { urls } from 'urls'

const PAGE = 'dashboard'

export const metadata = {
  icon: 'tachometer',
  page: PAGE,
  urls: urls[PAGE],
  hideCreate: true,
  isSoftDelete: false
}
const DashboardPage = createListPage({ metadata, api, actionCreators, Content })

export { DashboardPage }